import { filter, find, pipe, prop, propOr, sortBy } from 'ramda';
import { LOAN_STATUS, LOAN_STATUS_ORDER } from './constants';
import {
  getActiveShopCountry,
  getActiveType,
  getBrand,
  hasBarberBankAccount,
  hasShopBankAccount,
} from '../auth/selectors';
import { canUserViewBankAccounts } from '../common/helpers/users';
import { COUNTRY_NAME_BY_CODE } from '../main/shops/constants';

export const getLoansRoot = prop('loans');

export const getLoansList = pipe(
  getLoansRoot,
  propOr([], 'list'),
);

export const getDeletedLoansList = pipe(
  getLoansRoot,
  propOr([], 'deletedList'),
);

export const getActiveLoansList = pipe(
  getLoansList,
  filter(loan => [LOAN_STATUS.DELIVERED, LOAN_STATUS.ACCEPTED, LOAN_STATUS.PAID_OUT].includes(loan.status)),
  sortBy(loan => LOAN_STATUS_ORDER[loan.status]),
);

export const getLoanOffer = pipe(
  getLoansList,
  find(loan => [LOAN_STATUS.DELIVERED, LOAN_STATUS.ACCEPTED].includes(loan.status))
);

export const getLoanOfferStatus = pipe(
  getLoanOffer,
  propOr(undefined, 'status'),
);

export const isInitialLoansLoadDone = pipe(
  getLoansRoot,
  propOr(false, 'initialLoansLoadDone')
);

export const getIsDrawerOpened = pipe(
  getLoansRoot,
  propOr(false, 'drawerOpened')
);

export const canShowNoOfferView = state => (
  getLoansList(state).length === 0 && getDeletedLoansList(state).length === 0
  && (getActiveType(state) === 'barber' ? hasBarberBankAccount(state) : hasShopBankAccount(state))
  && canUserViewBankAccounts(state.auth.permissions)
  && !propOr(false, 'financingOffersDisabled', getBrand(state))
);

export const canUseStripeCapitalFinancing = state => getActiveShopCountry(state) === COUNTRY_NAME_BY_CODE.US;
